import { all, select, call, put } from 'redux-saga/effects';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { getProfileOwner } from '../../selectors/users';
import { isApiError } from '@wix/da-http-client/pkg/request';
import { requestPuppyGruser } from '../gruserHelpers';

function* fetchFromApi(params) {
  return yield call(
    requestPuppyGruser,
    {
      method: 'get',
      url: `/module/my_comments`,
      params,
    },
    undefined,
    'gruser'
  );
}

export default function* fetchMoreMyComments(action) {
  const { streamId } = action;

  const [offset, limit, streamParams, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
    select(getProfileOwner),
  ]);

  const queryParams = {
    moduleid: streamParams.moduleId,
    username: profileOwner.user.username,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response && !isApiError(response)) {
    const { hasMore, nextOffset, results } = response;

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: results,
      })
    );
  }

  // TODO error catching
}
